
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/tnc",
      function () {
        return require("private-next-pages/[slug]/tnc/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/tnc"])
      });
    }
  